<p-floatLabel>
  <p-autoComplete 
     [styleClass]="styleClass"
     [(ngModel)]="selectedCreditor" 
     [suggestions]="filteredCreditors"  
     (completeMethod)="filterCreditors($event)" 
     (onKeyUp)="onKeyUp($event)"
     (onSelect)="onSelectCreditor($event)"
     [dropdown]="true" 
     optionLabel="CompanyName"
     placeholder="Select Creditor"
     id="creditors"
     >
     <ng-template let-creditor pTemplate="item">
       <div class="flex align-items-center justify-content-between flex-1">
        <div>{{creditor.CompanyName}}</div>
        <div>{{creditor.CreditorId}}</div>
       </div>
     </ng-template>
  </p-autoComplete>
  <label for="creditors">Creditor</label>
</p-floatLabel>
